import React, { useState, useEffect, useRef } from 'react';
import './Stats.css';

function Stats() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({
    companies: 0,
    assets: 0,
    families: 0,
    countries: 0
  });

  const statsRef = useRef(null);

  const finalValues = {
    companies: 10,
    assets: 390,
    families: 7,
    countries: 9
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const currentRef = statsRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);

      setCounts({
        companies: Math.floor(easeOutQuart * finalValues.companies),
        assets: Math.floor(easeOutQuart * finalValues.assets),
        families: Math.floor(easeOutQuart * finalValues.families),
        countries: Math.floor(easeOutQuart * finalValues.countries)
      });

      if (currentStep >= steps) {
        setCounts(finalValues);
        clearInterval(timer);
      }
    }, stepDuration);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <section className={`stats${isVisible ? ' visible' : ''}`} ref={statsRef}>
      <div className="stats-overlay"></div>
      <div className="container">
        <div className="stats-header">
          <h2 className="stats-heading">TABIA GROUP EN CIFRAS</h2>
        </div>
        
        <div className="stats-grid">
          <div className="stat-item left">
            <div className="stat-content">
              <div className="stat-number">+ {counts.companies}</div>
              <div className="stat-label">COMPAÑÍAS EN EL GRUPO</div>
            </div>
          </div>

          <div className="stat-item right">
            <div className="stat-content">
              <div className="stat-number">+ {counts.assets}<span className="stat-suffix">M</span></div>
              <div className="stat-label">ACTIVOS GESTIONADOS</div>
            </div>
          </div>

          <div className="stat-item left">
            <div className="stat-content">
              <div className="stat-number">+ {counts.families}</div>
              <div className="stat-label">FAMILIAS BAJO GESTIÓN INMOBILIARIA</div>
            </div>
          </div>

          <div className="stat-item right">
            <div className="stat-content">
              <div className="stat-number">+ {counts.countries}</div>
              <div className="stat-label">PAÍSES CON PRESENCIA ACTIVA</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Stats;
